import { Engine } from "../Engine";
import { TickEvent } from "../../Common/Util/TickEventManager";

export class FPSCounter {
    private tick: TickEvent;
    private frames: number;
    private currentSecond: number;
    public fps: number;

    constructor(engine: Engine, callback: (counter: FPSCounter) => void) {
        this.frames = 0;
        this.fps = 0;
        this.currentSecond = new Date().getSeconds();

        this.tick = engine.tickEventManager.registerFrameEvent(() => {
            this.frames++;
            let newSecs = new Date().getSeconds();
            if (newSecs !== this.currentSecond) {
                this.currentSecond = newSecs;
                this.fps = this.frames;
                this.frames = 0;

                let title = engine.ctx.viewPort.toString() + " @ " + this.fps + " FPS";

                document.title = title;

                if (callback) {
                    callback(this);
                }
            }
        });
    }

    public cancel() {
        this.tick.cancel();
    }
}
